<div class="card-header bg-white d-flex justify-content-between align-items-center">
    <div>
        <i class="fas fa-money-check-alt text-gray text-opacity-50"></i>
        Datos Bancarios
    </div>
    <div class="btn-group my-n1">
        <button class="btn btn-white btn-sm border-0 text-gray" (click)="getBankAccount()"><i class="fas fa-sync"></i></button>
    </div>
</div>
@if(showSpinner){
<app-state-display state="loading"></app-state-display>
}
@if(account){
<div class="card-body p-3 text-dark fw-bold">
    <dl class="row mb-0 g-1">
        <dt class="col-sm-5 col-12"><i class="fa fa-university"></i> Banco:</dt>
        <dd class="col-sm-7 col-12">{{account.bank?.name || account.bank}}</dd>
        <dt class="col-sm-5 col-12"><i class="fa fa-wallet"></i> Cuenta:</dt>
        <dd class="col-sm-7 col-12">{{account.type_account?.name || account.accountType?.name}}</dd>
        <dt class="col-sm-5 col-12"><i class="fa fa-hashtag"></i> Número cuenta:</dt>
        <dd class="col-sm-7 col-12">{{account.number}}</dd>
    </dl>
</div>
}@else if(!showSpinner){
<app-state-display state="empty" message="Aún no se registran cuentas bancarias o no es el titular"></app-state-display>
}
